import { render, staticRenderFns } from "./ExtraServiceReportIssues.vue?vue&type=template&id=020ba8a2&"
import script from "@/scripts/modal/extraService/extraServiceReportIssues.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/extraService/extraServiceReportIssues.js?vue&type=script&lang=js&"
import style0 from "./ExtraServiceReportIssues.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports